import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
export const toAmendmentScope = (param)=>{
    let { currentFilter, selectedAgreementIds, totalMatchCount, activeFilterText } = param;
    return _object_spread({
        currentFilter,
        selectedAgreementIds: selectedAgreementIds != null && selectedAgreementIds.length > 0 ? selectedAgreementIds : null,
        matchedAgreementCount: totalMatchCount
    }, activeFilterText.length > 0 ? {
        activeFilterText
    } : {});
};
